import styled from 'styled-components';

import { SIZE, WHITE, GRADIENT_CATEGORY, ORANGE } from '../../const';

// const mapCategoryToColor = category => CATEGORIES[category] || ORANGE;

export const StyledSuggestPreview = styled.div`
    width: 100%;
    display: ${props => props.categoriesPage ? 'block' : 'flex'};
    margin-bottom: 12px;

    @media ${SIZE.laptopL} { 
        height: auto;
        background-position: center;
    }

    @media ${SIZE.tablet} { 
       flex-direction: column;
        margin-bottom: 0;
    }

    .leftBlock {
        height: 420px;
        overflow: hidden;
        margin-right: 30px;
        flex-grow: 1;

        .item {
            height: 420px;
            display: flex;

            .tagWrap {
                display: flex;
                width: 100%;
                flex-direction: row;
                justify-content: flex-start;
                margin-bottom: 0;
            }

            >div {
                height: 420px;
                padding: 280px 20px 48px;
            }

            div {
                display: flex !important;
                flex-direction: column;
                justify-content: flex-end;
            }

            @media ${SIZE.tablet} { 
                height: 230px;
                >div {
                    height: 230px;
                    padding: 35px;
                }
            }

            @media ${SIZE.mobileL} {

                 >div {
                    padding-right: 30px;
                    padding-left: 30px;
                }
            }
        }

        @media ${SIZE.tablet} { 
            width: 100%;
            height: auto;
            margin-bottom: 17px;
        }

    }
    .leftBlock.leftBlock-big{
        margin-right: 0;
    }

    .rightBlock {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .tablet {
            display: none
        }

        .item {
            display: none
        }

        &_item {
            width: 362px;
            height: 200px;
            overflow:hidden;
            .item {
                display: block
            }
        }

        @media ${SIZE.categorySwitch} { 
            &_item {
                width: 300px;
            }
        }
        
        @media ${SIZE.tablet} {
            .tablet {
                display: block
            }

            &_item {
                display: none
            }
                
            .item {
                width: 100%;
                display: grid;
                grid-template-rows: unset;
                grid-template-columns: 160px 1fr;
            }

            .item_title {
                margin: 0 0 10px 0;
            }
        }

        @media ${SIZE.mobileL} {
            .item_credits {
                display: none;
            }

            .item_title {
                margin: 0;
            }
        }

        @media ${SIZE.mobileM} {
            .item_title {
                font-size: 14px;
                max-height: 28px;
            }

            .item {
                grid-template-columns: 100px 1fr;
            }
        }

    }
`;

export const StyledCategoriesPreviewBlock = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 30px;
`;

export const StyledCategoriesSearch = styled.div`
    width: calc(33% - 30px);

    @media ${SIZE.tablet} { 
        display: none;
    }
`;

export const StyledCategoriesPreview = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    .item {
        font-weight: 600;
        font-size: 10px;
        line-height: 14px;
        text-align: center;
        color: #FFFFFF;
        height: 49px;
        width: 132px;
        background: ${GRADIENT_CATEGORY};
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        padding-top: 8px;
        margin-bottom: 15px;

        .img_wrapper {
            height: 14px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 4px;

            img {
                height: 14px;
                width: 100%;
            }
        }

        .title {
            height: 42px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        &:nth-child(1) {
            order: 1;
        }

        &:nth-child(2) {
            order: 0;
        }

        &:nth-child(3) {
            order: 1;
        }

        &:nth-child(4) {
            order: 1;
        }

        &:nth-child(5) {
            order: 1;
        }
    }
`;

export const StyledCategoryTag = styled.div`
    height: 20px;
    border-radius: 2px;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    display: inline-block;
    padding: 3px 5px;
    color: ${WHITE};
    margin-bottom: 7px;
    margin-right: 10px;
    background: ${props => props.tag_color || ORANGE};
    max-width: fit-content;
`;
